import { apiSlice } from './apiSlice';
import { Job } from '../../@types/jobs';

export const jobsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllFinishedJobs: builder.query<
      Job[],
      { id: number; isPersonalized: boolean; isUnread: boolean }
    >({
      query: ({ id, isPersonalized, isUnread }) =>
        `/jobs/check?isPersonalized=${isPersonalized}&isUnread=${isUnread}`,
    }),
    markJobsAsRead: builder.mutation({
      query: (jobIds) => ({
        url: `/jobs/read`,
        method: 'PUT',
        body: jobIds,
      }),
    }),
    createGlobalExportJob: builder.mutation({
      query: (exportJob) => ({
        url: '/export/global',
        method: 'POST',
        body: exportJob,
      }),
    }),
    createExportFavoriteJobs: builder.mutation({
      query: (exportFavoritesRequest) => ({
        url: '/export/jobs/favorites',
        method: 'POST',
        body: exportFavoritesRequest,
      }),
    }),
  }),
});

export const {
  useGetAllFinishedJobsQuery,
  useMarkJobsAsReadMutation,
  useCreateGlobalExportJobMutation,
  useCreateExportFavoriteJobsMutation,
} = jobsApiSlice;
